import React from "react";

function ProfileCard() {
  return (
    <>
      <div className="bg-[#fff] rounded-lg shadow-md w-80 max-w-full cursor-pointer overflow-hidden hover:translate-y-2 duration-500">
        <div className="">
          <img src="assets/images/user/user-img.jpg" alt="User Image" />
        </div>
        <div className="grid divide-y">
          <div className="p-5">
            <div className="inline-flex gap-2 text-[#666666] hover:text-[#000000]">
              <div className="w-6 h-6">
                <img src="assets/images/user/user-img.jpg" alt="User Image" />
              </div>
              <h4 className="uppercase font-semibold">Mochi</h4>
            </div>
            <h2 className="uppercase  font-semibold text-2xl">Mochi</h2>
          </div>

          <div className="text-[#666666] font-semibold capitalize flex justify-between p-5">
            <div className="grid gap-2">
              <p>Last sold for</p>
              <p className="uppercase">1.22 eth</p>
            </div>
            <div className="grid gap-2 text-right">
              <p>owned by</p>
              <div className="flex gap-2 items-center">
                <div className="w-6 h-6 rounded-full overflow-hidden">
                  <img src="assets/images/user/user.jpg" alt="User Image" />
                </div>
                <p className="normal-case">@y3rch</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ProfileCard;
